/** Roles that may instantiate: workspace_owner and org admin. delivery_owner is not a workspace role. */
export const TEMPLATE_INSTANTIATE_DENIED_COPY =
  'Only a workspace owner or an organization admin can create a project from a template.';

/** User-facing label for templateScope ORG. Never render the raw scope code. */
export const ORG_TEMPLATE_LABEL = 'Your organization';

export const PREFERRED_SHELF_EMPTY_GRID_COPY =
  'These templates are listed under Recommended by your organization.';
